
const HazardIdentificationSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            Comprehensive Hazard Identification and Training Solutions
          </h2>
          
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed mb-8">
            <p>
              Our team of experts assists companies in understanding and fulfilling their OSHA training requirements. We will work with you to identify the training that is required in your industry, determine the appropriate interval to train, and develop a training plan to accomplish those requirements, along with a list of optional or "best practice" courses for those companies ready for the next step on their safety journey. We make it straightforward to schedule and complete these essential training sessions in both English and Spanish.
            </p>
          </div>
          
          <div className="text-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/7dfadfa231ffd2bb6eba93e2cb6f7468.jpg"
              alt="OSHA Training Safety Consultants USA"
              className="w-full max-w-2xl mx-auto rounded-lg shadow-lg object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HazardIdentificationSection;